import React from 'react';
import styles from './LoadingSpinner.module.css';
import {loadingLottie} from '../../assets/lottie';
import Lottie from 'lottie-react';

interface LoadingSpinnerProps {
  size?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({size = 34}) => {
  return (
    <div className={styles.wrapper}>
      <Lottie
        animationData={loadingLottie}
        loop={true}
        style={{width: `${size}px`, height: `${size}px`}}
      />
    </div>
  );
};

export default LoadingSpinner;
